import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ecopro_logo from "../../../assets/images/teaser_ecopro_logo.png";
import brotherplus_logo from "../../../assets/images/BrotherPlus/BrotherConnectLogo.svg";
import { ReactComponent as RightArrowImg } from "../../../assets/images/rightArrow.svg";
import { ReactComponent as DownArrowImg } from "../../../assets/images/downArrow.svg";
import { ReactComponent as LogoutImg } from "../../../assets/images/logout.svg";
import { Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import './hamburgerMenuDesktopApp.css';
import useNavItems from "../../../utils/Dashboard/HamburgerNavItems";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { SignOut } from "../../../actions/Dashboard";
import { logoutProcess } from "../../../utils/Authentication/AppLogout";
import { BROTHER_PLUS, UNIQUE_ID_GA, ECOPRO, LOCALSESSIONDATAKEYS, ENROLLMENT_TYPE } from "../../../constants/AppConstants";
import { useTranslation } from "react-i18next";
import { routePath } from "../../../constants/Routes";
import MenuStripesLoader from "../SkeletonLoaders/MenuStripesLoader";
import { Is_BrotherPlus_Signup } from "../../../constants/AppMethod";
import { getLocalSessionData } from "../../../utils/Authentication/handleUserSession";

const HamburgerMenuDesktopApp = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const history = useHistory()
    const IsBrotherPlus_Signup = Is_BrotherPlus_Signup();
    const [expandedItem, setExpandedItem] = useState(null);
    const [activeNavItem, setActiveNavItem] = useState(null);

    const [subItemId, setSubItemId] = useState(null)
    const { t } = useTranslation(['translation']);
    const isOnConnectDevicePage = location.pathname === routePath.CONNECT_DEVICE_DASHBOARD;
    const { 
        userDeviceList_data 
    } = useSelector(state => state.ROOTREDUCER_RTK.GetUserEnrolledDevicesService);

    const [isEnrollmentBPlus, setEnrollmentBPlus] = useState();

     useEffect( () => {
        if(getLocalSessionData(LOCALSESSIONDATAKEYS.ENROLLMENT_TYPE) === undefined || getLocalSessionData(LOCALSESSIONDATAKEYS.ENROLLMENT_TYPE) === null){
            if(IsBrotherPlus_Signup) { 
                setEnrollmentBPlus(true);
            }
            else {
                setEnrollmentBPlus(false);
            }
        }
        else{
            const EnrolTypeBPlus = ( getLocalSessionData(LOCALSESSIONDATAKEYS.ENROLLMENT_TYPE) === ENROLLMENT_TYPE.BROTHER_PLUS ) ? true : false;
            setEnrollmentBPlus(EnrolTypeBPlus);
        }
        // eslint-disable-next-line
    }, [userDeviceList_data?.userEnrolledDeviceViewModel?.length] );

    useEffect(() => {
        setActiveNavItem(location.pathname);
        setExpandedItem(location.pathname);
    }, [location.pathname])

    useEffect(() => {
        setExpandedItem(expandedItem)
    }, [expandedItem])

    const handleLogout = () => {
        dispatch(SignOut());
        logoutProcess();
    };

    const handleItemClick = (itemId, itemLink) => {
        if (itemId === UNIQUE_ID_GA.logout) {
            handleLogout()
        }
        else {
            setExpandedItem(itemLink);
            history.push(itemLink);
        }
    };

    const handleSubItemClick = (itemId) => {
        setSubItemId(itemId)
        const element = document.getElementById(itemId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }

    const scenario = (isEnrollmentBPlus) ? BROTHER_PLUS : ECOPRO;
    const { section1, section2 } = useNavItems(scenario);
    return (
        <div className="hamburger-menu-desktop-wrapper hamburger-menu-desktop-view">
        { isEnrollmentBPlus === null ?
            <div className="menu-stacked-stripes-loader">
                <MenuStripesLoader sectionItems = {[3, 1, 1]} />
            </div>
            : (
           <>
            <div className="header">
                <div className="title offcanvas-title">
                    {
                        isEnrollmentBPlus === null || isEnrollmentBPlus === undefined ? (
                            <div className="brotherplus-logo">
                                <div className="web-form-input-spinner-wrapper">
                                    <div className="spinner-border" role="status"></div>
                                </div>
                            </div>
                        ) : isEnrollmentBPlus === true ? (
                            <img className="brotherplus-logo" src={brotherplus_logo} alt="BrotherPlus Logo" fetchPriority="high" />
                        ) : isEnrollmentBPlus === false ? (
                            <img className="ecopro-logo" src={ecopro_logo} alt="EcoPro Logo" fetchPriority="high"/>
                        ) : null
                    }
                </div>
            </div>
            <div className="body offcanvas-body">
                <div className="navbar-nav">
                    <div className="container">
                        {section1.map((val) => (
                            val.item_enabled &&
                            <div key={val.item_id} className={`nav-item ${(isEnrollmentBPlus) ? 'brother-plus-menu-container' : 'ecopro-menu-container'}`}>
                                <a id={val.item_id}
                                    href={val.item_link}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleItemClick(val.item_id, val.item_link, val.subItems && val.subItems.length > 0);
                                    }}
                                    className={`${(activeNavItem === val.item_link) ? 'active-link' : 'inactive-link'} ${isOnConnectDevicePage ? 'navigation-disabled' : 'navigation-enabled'}`}>
                                    <Row className="row-margin">
                                        <div className="col-10 row sidebar-nav-item-text-wrapper">
                                            <div className="col">{val.item_logo}</div>
                                            <span className={`col-10 `}>{val.item_name}</span>
                                        </div>
                                        <div className="col arrow">
                                            {location.pathname === val.item_link && val.subItems ? <DownArrowImg /> : <RightArrowImg />}
                                        </div>
                                    </Row>
                                </a>
                                {location.pathname === val.item_link && val.subItems && (
                                    <div className="sub-items">
                                        {val.subItems.map(subItem => (
                                            <a key={subItem.item_id}
                                                href={`${subItem.item_link}#${subItem.item_id}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleSubItemClick(subItem.item_id)

                                                }}
                                                className={`${(subItemId === subItem.item_id) ? 'active-link' : 'inactive-link'} sub-item`}>
                                                <Row className="sub-row-margin">
                                                    <div className="col-10 row">
                                                        <span className="col-10">{subItem.item_name}</span>
                                                    </div>
                                                    <div className="col arrow">
                                                        <RightArrowImg />
                                                    </div>
                                                </Row>
                                            </a>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                    {section2.length === 0 ? <></> : <div className="divider"></div>}
                    <div className="container">
                        {section2.map((val) => (
                            val.item_enabled && <a
                                id={val.item_id}
                                href={val.item_link}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleItemClick(val.item_id, val.item_link, val.subItems && val.subItems.length > 0);
                                }}
                                className={`${(activeNavItem === val.item_link) ? 'active-link' : 'inactive-link'} ${isOnConnectDevicePage ? 'navigation-disabled' : 'navigation-enabled'}`}>
                                <Row className="row-margin">
                                    <div className="col-10 row">
                                        <div className="col">{val.item_logo}</div>
                                        <span className="col-10">{val.item_name}</span>
                                    </div>
                                    <div className="col arrow">
                                        <RightArrowImg />
                                    </div>
                                </Row>
                            </a>
                        ))}
                    </div>
                    <div className="divider"></div>
                    <div className="container">
                        <Row className="row-margin logout-dashboard" onClick={() => handleLogout()}>
                            <div className="col-10 row">
                                <div className="col">{<LogoutImg />}</div>
                                <span className="col-10">{t("NAVIGATION_MENU.LOGOUT")}</span>
                            </div>
                            <div className="col arrow">
                                <RightArrowImg />
                            </div>
                        </Row>
                    </div>
                </div>
            </div>
            </> ) }
        </div>
    )


}
export default HamburgerMenuDesktopApp;